/**
 * @generated SignedSource<<b18a39078d1b618f4624318dc0acaadd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MerchantStoreState = "INACTIVE" | "LIVE" | "RETIRED" | "UNKNOWN" | "%future added value";
export type CreateMerchantStoreInput = {
  bannerBase64: string;
  lat?: number | null | undefined;
  lng?: number | null | undefined;
  logoBase64: string;
  name: string;
  organizationId: string;
  primaryColor?: string | null | undefined;
  secondaryColor?: string | null | undefined;
  websiteUrl?: string | null | undefined;
};
export type useMerchantStoreMutationsCreateMutation$variables = {
  input: CreateMerchantStoreInput;
};
export type useMerchantStoreMutationsCreateMutation$data = {
  readonly createMerchantStore: {
    readonly errors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly fields: ReadonlyArray<string> | null | undefined;
      readonly message: string | null | undefined;
      readonly shortMessage: string | null | undefined;
      readonly vars: any | null | undefined;
    }>;
    readonly result: {
      readonly banner: {
        readonly id: string;
        readonly url: string | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly lat: number | null | undefined;
      readonly lng: number | null | undefined;
      readonly logo: {
        readonly id: string;
        readonly url: string | null | undefined;
      } | null | undefined;
      readonly name: string;
      readonly oldId: string | null | undefined;
      readonly organizationId: string;
      readonly primaryColor: string | null | undefined;
      readonly secondaryColor: string | null | undefined;
      readonly state: MerchantStoreState | null | undefined;
      readonly websiteUrl: string | null | undefined;
    } | null | undefined;
  };
};
export type useMerchantStoreMutationsCreateMutation = {
  response: useMerchantStoreMutationsCreateMutation$data;
  variables: useMerchantStoreMutationsCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateMerchantStoreResult",
    "kind": "LinkedField",
    "name": "createMerchantStore",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MerchantStore",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "websiteUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lng",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondaryColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "logo",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "banner",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fields",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vars",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMerchantStoreMutationsCreateMutation",
    "selections": (v3/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMerchantStoreMutationsCreateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "2ddb2c58e4ade3bbf25ed26eb7ee6e7c",
    "id": null,
    "metadata": {},
    "name": "useMerchantStoreMutationsCreateMutation",
    "operationKind": "mutation",
    "text": "mutation useMerchantStoreMutationsCreateMutation(\n  $input: CreateMerchantStoreInput!\n) {\n  createMerchantStore(input: $input) {\n    result {\n      id\n      oldId\n      name\n      websiteUrl\n      lat\n      lng\n      primaryColor\n      secondaryColor\n      organizationId\n      state\n      logo {\n        id\n        url\n      }\n      banner {\n        id\n        url\n      }\n    }\n    errors {\n      message\n      fields\n      code\n      shortMessage\n      vars\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d70a2c37c37153a2c73e628ba9ecdb2";

export default node;
